import { render, staticRenderFns } from "./EditProfileForm.vue?vue&type=template&id=0abad609"
import script from "./EditProfileForm.vue?vue&type=script&lang=js"
export * from "./EditProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports